import React, { Component } from 'react';
import './Signin.css';
import Navbar from '../Components/Navbar/Navbar'
import logoblue from '../../../image/logoblue.png'
import { Link } from 'react-router-dom';
import HandleRes from '../Components/HandleRes/HandleRes';
import axios from 'axios';
import { LinkAPI } from '../../../API/API'
import Footer from '../Components/Footer/Footer'

class Signin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "user@user.com",
      password: "123456789",
      emailError: "",
      passwordError: "",
      networkError: false,
      errordatamessage: false,
      errordatamessagetext: '',
      hasError: false,
    }
  }
  handleChange = event => {
    const isCheckbox = event.target.type === "checkbox";
    this.setState({
      [event.target.name]: isCheckbox
        ? event.target.checked
        : event.target.value
    });
  };
  componentDidMount() {
    window.scrollTo(0, 0)
  }
  validate = () => {
    let emailError = "";
    let passwordError = "";
    // let passwordError = "";

    if (this.state.password.length < 8) {
      passwordError = "الرقم السري غير صحيح";
    }

    if (!this.state.email.includes("@")) {
      emailError = "البرد الالكتروني غير صحيح";
    }

    if (emailError || passwordError) {
      this.setState({ emailError, passwordError });
      return false;
    }

    return true;
  };

  handleSubmit = event => {
    event.preventDefault();
    const { email, password } = this.state
    const isValid = this.validate();
    if (isValid) {
      // clear form
      axios.post(`${LinkAPI}/api/businessowner/login`, { email: email, password: password },{
        headers:{ lang:"ar"}
       
      }
      ).then(res => {
        localStorage.setItem("userToken", res.data.businessOwner.token)
        localStorage.setItem("KaynuserName", res.data.businessOwner.name)
        window.location.replace("/AR/orders");

      }).catch(error => {
        if (!error.response) {
          this.setState({
            networkError: true
          })
        }else if (error.response.status===400) {
          localStorage.setItem("userTokentConfirmData", error.response.data.token)
          window.location.replace("/AR/ConfirmPhone");
        } else if (error.response.status === 402) {
          localStorage.setItem("userToken", '')
          window.location.replace("/AR/SignIn");
        } else if (error.response.data.message) {
          this.setState({
            emailError: "",
            passwordError: "",
            errordatamessage: true,
            errordatamessagetext: error.response.data.message
          })
        } else {
          this.setState({
            hasError: true,
          })
        }
      })
    }
  };
  render() {
    document.title ="kayn | تسجيل دخول "; 
        document.getElementsByTagName("META")[1].content="كاين | تسجيل دخول ";
        document.documentElement.lang = 'ar';
    return (
      <div className="AppAR signin">
        <Navbar />
        <div className='container'>
          <div className="Sign row my-0">
            
            <div className="col-md-6 form float-md-left  ">
              <div className="contantform text-center p-4 ">
                <h3 className="fontsize1 my-4">تسجيل دخول</h3>
                <p className="fontsize6 mt-4 mb-1">تسجيل الدخول لمتابعة الوصول إلى الصفحات</p>
                <p className="fontsize6  m-0">E-mail:user@user.com</p>
                <p className="fontsize6 m-0">password:123456789</p>
                <p className="fontsize6  m-0">للدخول كا مسؤل<Link to="/admin/Signin"> اضغط هنا </Link></p>

                <form className="px-lg-5" onSubmit={this.handleSubmit}>
                  <div className="form-group mb-4 mt-2">
                    <input type="email" className={"form-control badge-pill p-3 " + (this.state.emailError ? 'is-invalid' : '')} placeholder="البريد الالكتروني" name="email" value={this.state.email}
                      onChange={this.handleChange} required />
                    <div style={{ fontSize: 12, color: "red" }}>
                      {this.state.emailError}
                    </div>
                  </div><div className="form-group my-4">
                    <input type="password" className={"form-control badge-pill p-3 " + (this.state.passwordError ? 'is-invalid' : '')} placeholder=" الرقم السري" name="password" value={this.state.password}
                      onChange={this.handleChange} required />
                    <div style={{ fontSize: 12, color: "red" }}>
                      {this.state.passwordError}
                    </div>
                    {(this.state.errordatamessage ?
                      <div className="px-2" style={{ fontSize: 12, color: "red" }}>
                        {this.state.errordatamessagetext}
                      </div> : '')}
                  </div>
                  <div className="text-right py-1">
                    <Link to="/AR/ForgetPassword"><span className="pointer fontsize11 text-muted py-1 my-1">هل نسيت كلمة السر</span></Link>
                  </div>
                  <button type="submit" className="btn btn-primary badge-pill btn-block shadow p-2 mb-2"  >تسجيل الدخول</button>

                </form>



                <div className="mt-5 px-5">
                  <p className="fontsize6 my-4">لا تملك حسابا حتى الآن؟ </p>

                  <Link to="/AR/SignUp" className="btn badge-pill btn-block p-2 border shadow"  >سجل الان</Link>
                </div>
              </div>
            </div>
            <div className=" logoform col-6 d-flex align-content-end flex-wrap ">
              <div className="col-12 text-center mt-auto p-2 bd-highlight"><Link to="/AR/"><img className="logo" src={logoblue} alt="kayn" /></Link>       </div>
              <p className="fontsize2 text-center mb-5 col-12">طلبك الخاصة بك ... طريقك</p>
            </div>
          </div>
        </div>
        <Footer/>
        {(this.state.networkError ? <HandleRes title="تاكد باتصالك بالانترنت ثم عاود المحاوله" stylecss="alert-danger" /> : '')}
                {(this.state.hasError ? <HandleRes title="  هناك مشكلة في طلبك" stylecss="alert-danger" /> : '')}
   </div>
    )
  }
}
export default Signin;